<template>
  <div class="deposit-info">
    <p class="submit">提交保证金</p>
    <!-- 商品信息部分 -->
    <div class="prod-info">
      <div class="prod-info-tile">
        <span>商品信息</span>
        <span>保证金</span>
      </div>
      <div class="prod-info-content">
        <div class="info-left">
          <div class="left-img">
            <img :src="carDetailsData.imageUrl" alt="" mode="aspectFit" />
          </div>
          <div class="left-text">
            <div class="prod-title hidden">
              {{ bondInfo.item && bondInfo.item.name }} &nbsp;
              <span v-if="bondInfo.item.type == 0">
                <span v-for="(elm, index) in skuInfo.saleAttributes" :key="index">
                  {{ elm.attrVal }}
                </span>
              </span>
            </div>
            <div class="prod-price hidden" v-if="_get(auctionData, 'extra.originPrice', 0) !== 0">
              官方指导价 {{ _get(auctionData, 'extra.originPrice', 0) }}
            </div>
            <div class="prod-dealer hidden" v-if="bondInfo.item.type == 0 && dealerName">经销商：{{ dealerName }}</div>
            <div class="prod-attribute" v-if="bondInfo.item.type != 0">
              <span v-for="(elm, index) in skuInfo.saleAttributes" :key="index">
                {{ elm.attrKey }}：{{ elm.attrVal }}
              </span>
            </div>
          </div>
        </div>
        <div class="info-right">
          ¥{{
            isFreeFall
              ? bondInfo.item.activityItemInfoDto.auctionDto.rpAuctionRuleDto.deposit / 100
              : bondInfo.item.activityItemInfoDto.auctionDto.deposit / 100
          }}
        </div>
      </div>
    </div>

    <!-- 保证金流程 -->
    <div class="deposit-process">
      <div class="process-title">
        <div class="title-content">
          <span class="line"></span>
          <span class="title-text">保证金流程</span>
          <span class="line"></span>
        </div>
      </div>
      <div class="process-img">
        <img :src="isFreeFall ? reductionPriceImg : increasePriceImg" />
      </div>
      <div class="process-bottom">
        <div class="bottom-left">
          <span class="bottom-text">保证金:</span>
          <span class="bottom-price"
            >¥{{
              isFreeFall
                ? bondInfo.item.activityItemInfoDto.auctionDto.rpAuctionRuleDto.deposit / 100
                : bondInfo.item.activityItemInfoDto.auctionDto.deposit / 100
            }}</span
          >
        </div>
        <div class="bottom-right" @click="bondConfirm">同意并支付</div>
      </div>
    </div>
  </div>
</template>

<script>
import { _get, setStorage, getStorage } from '@/lib/utils'
import increasePriceImg from '@/assets/images/activity/auction/bond-process.png'
import reductionPriceImg from '@/assets/images/activity/auction/bond-process-auction.png'

export default {
  data() {
    return {
      dataInfo: {},
      bondInfo: {},
      skuInfo: {},
      auctionData: {},
      dealerName: '',
      // 车的详细信息
      carDetailsData: {
        // 图片地址
        imageUrl: ''
      },
      isFreeFall: false,
      increasePriceImg: increasePriceImg,
      reductionPriceImg: reductionPriceImg
    }
  },
  created() {
    if (Object.keys(this.$route.params).length === 0) {
      this.dataInfo = getStorage('dataInfo', 'sessionStorage')
      this.bondInfo = getStorage('bondInfo', 'sessionStorage')
      this.auctionData = getStorage('auctionData', 'sessionStorage')
      this.dealerName = getStorage('dealerName', 'sessionStorage')
      this.carDetailsData = getStorage('carDetailsData', 'sessionStorage')
      this.isFreeFall = getStorage('isFreeFall', 'sessionStorage')
    } else {
      this.dataInfo = this.$route.params.pageData
      this.bondInfo = this.$route.params.bondInfo
      this.auctionData = this.$route.params.auctionData
      this.carDetailsData = this.$route.params.carDetailsData
      this.isFreeFall = this.$route.params.isFreeFall
      setStorage('dataInfo', this.dataInfo, 'sessionStorage')
      setStorage('bondInfo', this.bondInfo, 'sessionStorage')
      setStorage('auctionData', this.auctionData, 'sessionStorage')
      setStorage('carDetailsData', this.carDetailsData, 'sessionStorage')
      setStorage('isFreeFall', this.isFreeFall, 'sessionStorage')
    }
    if (this.$route.params.dealerName) {
      this.dealerName = this.$route.params.dealerName
      setStorage('dealerName', this.dealerName, 'sessionStorage')
    }
    this.bondInfo.skus.forEach((item) => {
      if (item.skuId === this.dataInfo.skuId) {
        this.skuInfo = item
      }
    })
  },
  methods: {
    _get,
    bondConfirm() {
      let itemInfo = {
        mainImage: this.bondInfo.item.mainImage,
        type: this.bondInfo.item.type,
        id: this.bondInfo.item.id,
        activityId: this.bondInfo.item.activityItemInfoDto.activityInfoDto.id
      }
      if (this.bondInfo.item.type === 0) {
        itemInfo.skuName = ''
        this.skuInfo.saleAttributes.forEach((item) => {
          itemInfo.skuName = itemInfo.skuName + item.attrVal + '/'
        })
        itemInfo.skuName = itemInfo.skuName.substring(0, itemInfo.skuName.length - 1)
      } else {
        itemInfo.skuName = ''
        this.skuInfo.saleAttributes.forEach((item) => {
          itemInfo.skuName = itemInfo.skuName + item.attrKey + ':' + item.attrVal + '/'
        })
        itemInfo.skuName = itemInfo.skuName.substring(0, itemInfo.skuName.length - 1)
      }
      this.$router.push({
        name: 'bond-confirm',
        params: {
          dataInfo: this.dataInfo,
          bondInfo: this.bondInfo,
          itemInfo: itemInfo,
          dealerName: this.dealerName,
          carDetailsData: this.carDetailsData,
          isFreeFall: this.isFreeFall
        }
      })
      // if (this.bondInfo.item.type !== 0) {
      //   this.$router.push(
      //     '/order/bondConfirm/' +
      //       this.bondInfo.item.activityItemInfoDto.activityInfoDto.id +
      //       `?deposit=` +
      //       this.bondInfo.item.activityItemInfoDto.auctionDto.deposit +
      //       '&itemName=' +
      //       this.bondInfo.item.name +
      //       '&item=' +
      //       JSON.stringify(itemInfo) +
      //       '&skuId' +
      //       this.dataInfo.skuId
      //   )
      // } else {
      //   this.$router.push(
      //     '/order/bondConfirm/' +
      //       this.bondInfo.item.activityItemInfoDto.activityInfoDto.id +
      //       `?deposit=` +
      //       this.bondInfo.item.activityItemInfoDto.auctionDto.deposit +
      //       '&itemName=' +
      //       this.bondInfo.item.name +
      //       '&item=' +
      //       JSON.stringify(itemInfo) +
      //       '&dealerName=' +
      //       this.dealerName
      //   )
      // }
    }
  }
}
</script>
<style lang="scss" scoped>
.hidden {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.deposit-info {
  width: 1360px;
  height: auto;
  margin: 0 auto;
  margin-bottom: 50px;

  .submit {
    height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 25px;
    margin-top: 20px;
    margin-bottom: 15px;
  }

  .prod-info {
    width: 100%;
    height: 236px;
    box-sizing: border-box;
    border: 1px solid #d0d0d0;
    margin-bottom: 15px;

    .prod-info-tile {
      box-sizing: border-box;
      width: 100%;
      height: 49px;
      background: #000000;
      font-size: 16px;
      color: #ffffff;
      line-height: 22px;
      padding: 14px 38px 13px 30px;
      display: flex;
      justify-content: space-between;
    }

    .prod-info-content {
      box-sizing: border-box;
      width: 100%;
      height: 186px;
      padding: 0 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .info-left {
        display: flex;
        align-items: center;

        .left-img {
          width: 202px;
          height: 143px;
          margin-right: 15px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .left-text {
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          line-height: 30px;

          .prod-title {
            width: 400px;
            font-size: 18px;
            font-weight: 500;
            color: #040404;
            line-height: 25px;
            margin-bottom: 10px;
          }

          .prod-price,
          .prod-dealer {
            width: 400px;
          }
        }
      }

      .info-right {
        font-size: 18px;
        font-weight: 500;
        color: #c6001f;
        line-height: 25px;
      }
    }
  }

  .deposit-process {
    width: 100%;
    height: 558px;
    box-sizing: border-box;
    border: 1px solid #d0d0d0;

    .process-title {
      width: 100%;
      height: 50px;
      background: #f5f5f5;
      display: flex;
      justify-content: center;
      align-items: center;
      border-bottom: 1px solid #d0d0d0;

      .title-content {
        width: 128px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .line {
          width: 4px;
          height: 1px;
          background-color: #de9e72;
        }

        .title-text {
          font-size: 18px;
          color: #040404;
          line-height: 25px;
        }
      }
    }

    .process-img {
      width: 100%;
      height: 452px;
      box-sizing: border-box;
      border-bottom: 1px solid #d0d0d0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #fff;
      img {
        width: 481px;
        height: 383px;
      }
    }

    .process-bottom {
      width: 100%;
      height: 56px;
      box-sizing: border-box;
      display: flex;
      align-items: center;

      .bottom-left {
        width: 1140px;
        height: 100%;
        padding-left: 30px;
        display: flex;
        align-items: center;

        .bottom-text {
          font-size: 16px;
          color: #333333;
          line-height: 22px;
          margin-right: 10px;
        }

        .bottom-price {
          font-size: 26px;
          font-weight: 500;
          color: #c6001f;
          line-height: 37px;
        }
      }

      .bottom-right {
        box-sizing: border-box;
        width: 220px;
        height: 54px;
        position: relative;
        top: -2px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #c6001f;
        font-size: 20px;
        font-weight: 400;
        color: #ffffff;

        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
